<template>
  <div>
    <b-row v-if="$store.state.global.grants" class="mb-3">
      <b-col>
        <search-box v-model="query" />
      </b-col>
      <b-col class="text-right">
        <b-button
          v-if="auth.user.selectedAccess.can_manage_users"
          variant="outline-primary"
          size="sm"
          @click="addUser()"
        >
          <span v-label-key="'ADD_USER'">Add User</span>
        </b-button>
      </b-col>
    </b-row>
    <div v-if="$store.state.global.loading">
      <loading-spinner />
    </div>
    <div v-else>
      <b-table-simple
        v-if="$store.state.global.grants"
        class="table table-striped"
      >
        <b-thead>
          <b-tr>
            <b-th><span v-label-key="'EMAIL'">Email</span></b-th>
            <b-th><span v-label-key="'VIEW_REPORTS'">View Reports</span></b-th>
            <b-th
              ><span v-label-key="'MODIFY_SETTINGS'"
                >Modify Settings</span
              ></b-th
            >
            <b-th><span v-label-key="'MANAGE_USERS'">Manage Users</span></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="user in search($store.state.global.grants, query)"
            :key="user.id"
            @click="editUser(user)"
          >
            <b-td>{{ user.email }}</b-td>
            <b-td><span v-label-key="'YES'">Yes</span></b-td>
            <b-td>{{
              user.can_modify_settings ? getLabel("YES") : getLabel("NO")
            }}</b-td>
            <b-td>{{
              user.can_manage_users ? getLabel("YES") : getLabel("NO")
            }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div
        v-if="
          $store.state.global.grants && $store.state.global.grants.length == 0
        "
      >
        <span v-label-key="'NO_USERS'">No users</span>
      </div>
    </div>

    <b-modal ref="userModal" title="Add/Edit Access">
      <div v-if="activeGrant" class="modal-body">
        <form>
          <div class="form-group">
            <label v-label-key="'EMAIL'">Email</label>
            <input
              v-model="activeGrant.email"
              type="email"
              class="form-control"
              required
            />
          </div>

          <label class="form-check">
            <input
              v-model="activeGrant.can_modify_settings"
              type="checkbox"
              class="form-check-input"
            />
            <span class="form-check-label" v-label-key="'CAN_MODIFY_SETTINGS'"
              >Can Modify Settings</span
            >
          </label>

          <label class="form-check">
            <input
              v-model="activeGrant.can_manage_users"
              type="checkbox"
              class="form-check-input"
            />
            <span class="form-check-label" v-label-key="'CAN_MANAGE_USERS'"
              >Can Manage Users</span
            >
          </label>
        </form>
      </div>
      <div v-if="activeGrant" slot="modal-footer">
        <b-button
          v-if="activeGrant.id"
          type="button"
          variant="danger"
          class="mr-2"
          @click="removeAccess()"
        >
          <span v-label-key="'REMOVE_ACCESS'">Remove Access</span>
        </b-button>
        <b-button
          v-if="activeGrant.id"
          type="button"
          variant="primary"
          @click="modifyAccess()"
        >
          <span v-label-key="'SAVE_CHANGES'">Save Changes</span>
        </b-button>
        <b-button
          v-if="!activeGrant.id"
          type="button"
          variant="primary"
          @click="grantAccess()"
        >
          <span v-label-key="'GRANT_ACCESS'">Grant Access</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import $auth from "@/services/auth";
import $api from "@/services/api";
import $search from "@/services/search";
import LoadingSpinner from "@/components/LoadingSpinner";
import SearchBox from "@/components/SearchBox";
import { mapGetters } from "vuex";

export default {
  name: "UserList",
  components: {
    LoadingSpinner,
    SearchBox,
  },
  /* eslint-disable-next-line vue/prop-name-casing, vue/require-prop-types */
  props: ["distributor_id", "subdistributor_id", "chain_id", "store_id"],
  computed: {
    ...mapGetters("translations", {
      getLabel: "getLabel",
    }),
  },
  data() {
    return {
      auth: $auth,
      search: $search,
      query: null,
      grants: null,
      activeGrant: null,
    };
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      let params = {};
      if (this.distributor_id) {
        params.distributor_id = this.distributor_id;
      }
      if (this.subdistributor_id) {
        params.subdistributor_id = this.subdistributor_id;
      } 
      if (this.chain_id) {
        params.chain_id = this.chain_id;
      }
      if (this.store_id) {
        params.store_id = this.store_id;
      }
      
      // const params = {
      //   distributor_id: this.distributor_id,
      //   subdistributor_id: this.subdistributor_id,
      //   chain_id: this.chain_id,
      //   store_id: this.store_id,
      // };
      this.$store.dispatch("global/getUsers", params);
    },
    addUser() {
      this.$refs.userModal.show();
      const activeGrant = {};

      if (this.distributor_id) {
        activeGrant.distributor_id = this.distributor_id;
        activeGrant.role = "distributor";
      } else if (this.subdistributor_id) {
        activeGrant.subdistributor_id = this.subdistributor_id;
        activeGrant.role = "subdistributor";
      } else if (this.chain_id) {
        activeGrant.chain_id = this.chain_id;
        activeGrant.role = "chain";
      } else if (this.store_id) {
        activeGrant.store_id = this.store_id;
        activeGrant.role = "store";
      }
      this.activeGrant = activeGrant;
      // $("#").modal("show");
    },
    editUser(user) {
      this.$refs.userModal.show();
      if (this.auth.user.selectedAccess.can_manage_users) {
        this.activeGrant = user;
        // $("#userModal").modal("show");
      }
    },
    removeAccess() {
      $api
        .delete(`/v1/dashboard/accessgrants/${this.activeGrant.id}`)
        .then(this.refreshData);
      // $("#userModal").modal("hide");
      this.$refs.userModal.hide();
    },
    grantAccess() {
      $api
        .post("/v1/dashboard/accessgrants", this.activeGrant)
        .then(this.refreshData);
      // $("#userModal").modal("hide");
      this.$refs.userModal.hide();
    },
    modifyAccess() {
      $api
        .put(
          `/v1/dashboard/accessgrants/${this.activeGrant.id}`,
          this.activeGrant,
        )
        .then(this.refreshData);
      // $("#userModal").modal("hide");
      this.$refs.userModal.hide();
    },
  },
};
</script>
